import React from 'react';
import { CalendarBlank, Clock, Users } from '@phosphor-icons/react';

// Compact chip strip showing key session dates and spots.
function formatDate(iso) {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: 'short', day: 'numeric',
      hour: 'numeric', minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

export default function SessionDatesStrip({ session, spots, dense = false }) {
  const startStr = formatDate(session.starts_at);
  const closeStr = formatDate(session.registration_closes_at);
  const filled = spots?.filled;
  const max = spots?.max;
  return (
    <div className={`flex flex-wrap gap-x-3 gap-y-1 text-[11px] text-[#6a766e] ${dense ? '' : 'mt-1'}`} data-testid="session-dates-strip">
      {startStr && (
        <span className="inline-flex items-center gap-1" data-testid="session-starts-at">
          <CalendarBlank size={11} /> Starts {startStr}
        </span>
      )}
      {closeStr && (
        <span className="inline-flex items-center gap-1" data-testid="session-closes-at">
          <Clock size={11} /> Reg closes {closeStr}
        </span>
      )}
      {(filled !== undefined && max !== undefined) && (
        <span className="inline-flex items-center gap-1" data-testid="session-spots-chip">
          <Users size={11} /> {filled} / {max} spots
        </span>
      )}
    </div>
  );
}
